import React from 'react';
import Icon from './Icon';
import ThemeToggle from './ThemeToggle';

const SettingsView: React.FC = () => {
  return (
    <>
      <div className="section-header">Darstellung</div>
      <div className="ios-list">
        <div className="ios-row">
          <div className="row-icon" style={{ background: 'var(--ios-indigo)' }}>
            <Icon name="moon" size={16} />
          </div>
          <div className="row-main">
            <div className="row-title">Dark Mode</div>
            <div className="row-subtitle">Dunkle Oberfläche mit Liquid-Glass</div>
          </div>
          <div className="row-aside">
            <ThemeToggle />
          </div>
        </div>
      </div>

      <div className="section-header">Über Cabo</div>
      <div className="ios-list">
        <div className="ios-row">
          <div className="row-icon pink"><Icon name="sparkles" size={16} /></div>
          <div className="row-main">
            <div className="row-title">Cabo Punkte-Tracker</div>
            <div className="row-subtitle">iOS 26 Liquid Glass Interface</div>
          </div>
        </div>
        <div className="ios-row">
          <div className="row-icon"><Icon name="info" size={16} /></div>
          <div className="row-main">
            <div className="row-title">Spielregel</div>
            <div className="row-subtitle">Der Spieler mit den wenigsten Punkten gewinnt.</div>
          </div>
        </div>
        <div className="ios-row">
          <div className="row-icon warning"><Icon name="target" size={16} /></div>
          <div className="row-main">
            <div className="row-title">Cabo-Ruf</div>
            <div className="row-subtitle">Niedrigste Punkte = 0 · Sonst +5 Strafpunkte</div>
          </div>
        </div>
        <div className="ios-row">
          <div className="row-icon danger"><Icon name="flame" size={16} /></div>
          <div className="row-main">
            <div className="row-title">100-Punkte-Regel</div>
            <div className="row-subtitle">Bei exakt 100 wird auf 50 zurückgesetzt.</div>
          </div>
        </div>
      </div>

      <div className="section-footer" style={{ textAlign: 'center', opacity: 0.6 }}>
        Gebaut mit ♥ · v2.0 Liquid Glass
      </div>
    </>
  );
};

export default SettingsView;
